import React from 'react';
export function Hero() {
  return <section className="bg-rise-white text-rise-black py-10 md:py-16 px-6 flex flex-col justify-center min-h-0 overflow-hidden" data-id="element-208">
      <div className="max-w-rise-content mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-209">
        {/* Text Content */}
        <div className="flex flex-col items-center text-center order-1 lg:order-1" data-id="element-210">
          {/* Title — always first on mobile */}
          <h1 className="font-playfair text-[36px] md:text-[56px] leading-[1.1] mb-6" data-id="element-211">
            Ieși din blocaj.
            <br data-id="element-212" />
            Construiește-ți o viață cu sens.
          </h1>

          {/* These elements hide on mobile, shown on desktop inline */}
          <div className="hidden lg:block" data-id="element-213">
            <p className="font-playfair italic text-rise-gold text-[24px] md:text-[32px] mb-8" data-id="element-214">
              Descoperă Comunitatea și Workshop-urile R.I.S.E.
            </p>

            <div className="font-dm-sans text-[11px] md:text-[13px] tracking-[0.2em] uppercase mb-8 text-rise-gray flex flex-wrap gap-3 md:gap-4" data-id="element-215">
              <span data-id="element-216">Realitate</span>
              <span data-id="element-217">•</span>
              <span data-id="element-218">Identitate</span>
              <span data-id="element-219">•</span>
              <span data-id="element-220">Stabilitate</span>
              <span data-id="element-221">•</span>
              <span data-id="element-222">Evoluție</span>
            </div>

            <p className="font-dm-sans text-[19px] text-rise-gray max-w-xl mb-12 leading-relaxed" data-id="element-223">
              Un spațiu modern și structurat pentru tineri adulți (20–35) care
              se simt confuzi, se autosabotează sau amână decizii importante și
              vor claritate, stabilitate și pași concreți, fără presiune și fără
              judecată.
            </p>

            <div className="flex flex-col gap-3 w-full max-w-md mx-auto items-center" data-id="element-224">
              <a href="https://comunitatearise.ro/comunitaterise" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-3 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors flex items-center justify-center" data-id="element-225">
                Intră în Comunitatea R.I.S.E.
              </a>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-3 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors flex items-center justify-center" data-id="element-226">
                Rezervă Sesiunea Cadou 1 la 1 de Coaching
              </a>
            </div>
          </div>
        </div>

        {/* Image & Decorations */}
        <div className="relative w-full max-w-[280px] lg:max-w-md mx-auto lg:ml-auto order-2 lg:order-2" data-id="element-227">
          {/* Large outer arc — top right */}
          <svg className="absolute -top-16 -right-16 w-72 h-72 text-rise-gold pointer-events-none hidden lg:block" viewBox="0 0 200 200" fill="none" stroke="currentColor" strokeWidth="0.6" data-id="element-228">
            <circle cx="100" cy="100" r="95" strokeDasharray="4 6" data-id="element-229" />
            <circle cx="100" cy="100" r="80" strokeDasharray="1 8" data-id="element-230" />
          </svg>

          {/* Small concentric circles — top left */}
          <svg className="absolute -top-8 -left-8 w-24 h-24 text-rise-gold pointer-events-none" viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-231">
            <circle cx="40" cy="40" r="38" data-id="element-232" />
            <circle cx="40" cy="40" r="30" data-id="element-233" />
            <circle cx="40" cy="40" r="22" data-id="element-234" />
          </svg>

          {/* Dot grid — bottom left */}
          <svg className="absolute -bottom-14 -left-14 w-40 h-40 text-rise-gold/50 pointer-events-none hidden lg:block" viewBox="0 0 120 120" fill="none" data-id="element-235">
            <pattern id="hero-dots-grid" x="0" y="0" width="16" height="16" patternUnits="userSpaceOnUse" data-id="element-236">
              <circle cx="2" cy="2" r="1.2" fill="currentColor" data-id="element-237" />
            </pattern>
            <rect width="120" height="120" fill="url(#hero-dots-grid)" data-id="element-238" />
          </svg>

          {/* Diagonal thin lines — bottom right */}
          <svg className="absolute -bottom-10 -right-10 w-36 h-36 text-rise-gold/40 pointer-events-none hidden lg:block" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="0.4" data-id="element-239">
            <line x1="0" y1="100" x2="100" y2="0" data-id="element-240" />
            <line x1="20" y1="100" x2="100" y2="20" data-id="element-241" />
            <line x1="40" y1="100" x2="100" y2="40" data-id="element-242" />
            <line x1="60" y1="100" x2="100" y2="60" data-id="element-243" />
          </svg>

          {/* Corner bracket accents — top right */}
          <svg className="absolute -top-5 -right-5 w-16 h-16 text-rise-gold pointer-events-none" viewBox="0 0 50 50" fill="none" stroke="currentColor" strokeWidth="1.2" data-id="element-244">
            <path d="M50 0 L50 15 M50 0 L35 0" data-id="element-245" />
          </svg>

          {/* Corner bracket accents — bottom left */}
          <svg className="absolute -bottom-5 -left-5 w-16 h-16 text-rise-gold pointer-events-none" viewBox="0 0 50 50" fill="none" stroke="currentColor" strokeWidth="1.2" data-id="element-246">
            <path d="M0 50 L0 35 M0 50 L15 50" data-id="element-247" />
          </svg>

          {/* Small gold filled dots as accents */}
          <div className="absolute -top-3 right-12 w-2.5 h-2.5 rounded-full bg-rise-gold pointer-events-none" data-id="element-248"></div>
          <div className="absolute top-16 -right-6 w-2 h-2 rounded-full bg-rise-gold/60 pointer-events-none hidden lg:block" data-id="element-249"></div>
          <div className="absolute -bottom-4 left-20 w-3 h-3 rounded-full bg-rise-gold pointer-events-none" data-id="element-250"></div>
          <div className="absolute bottom-24 -left-4 w-1.5 h-1.5 rounded-full bg-rise-gold/80 pointer-events-none hidden lg:block" data-id="element-251"></div>

          {/* Gold offset border */}
          <div className="absolute inset-0 border border-rise-gold/70 rounded-xl translate-x-4 translate-y-4 lg:translate-x-5 lg:translate-y-5 pointer-events-none" data-id="element-252"></div>

          {/* Second offset border */}
          <div className="absolute inset-0 border border-rise-gold/30 rounded-xl translate-x-7 translate-y-1 lg:translate-x-8 lg:translate-y-2 pointer-events-none hidden lg:block" data-id="element-253"></div>

          {/* Main Image */}
          <img src="https://cdn.magicpatterns.com/uploads/5cTB7VyUXGVsL6aadBqWkg/Teodora_2.jpg" alt="Teodora Trifu" className="w-full h-auto object-cover rounded-xl shadow-lg relative z-10" data-id="element-254" />
        </div>

        {/* Mobile-only content below photo */}
        <div className="flex flex-col items-center text-center order-3 lg:hidden" data-id="element-255">
          <p className="font-playfair italic text-rise-gold text-[26px] mb-6" data-id="element-256">
            Descoperă Comunitatea și Workshop-urile R.I.S.E.
          </p>

          <div className="font-dm-sans text-[13px] tracking-[0.2em] uppercase mb-6 text-rise-gray flex flex-wrap justify-center gap-3" data-id="element-257">
            <span data-id="element-258">Realitate</span>
            <span data-id="element-259">•</span>
            <span data-id="element-260">Identitate</span>
            <span data-id="element-261">•</span>
            <span data-id="element-262">Stabilitate</span>
            <span data-id="element-263">•</span>
            <span data-id="element-264">Evoluție</span>
          </div>

          <p className="font-dm-sans text-[17px] text-rise-gray max-w-xl mb-10 leading-relaxed" data-id="element-265">
            Un spațiu modern și structurat pentru tineri adulți (20–35) care se
            simt confuzi, se autosabotează sau amână decizii importante și vor
            claritate, stabilitate și pași concreți, fără presiune și fără
            judecată.
          </p>

          <div className="flex flex-col items-center gap-4 w-full" data-id="element-266">
            <a href="https://comunitatearise.ro/comunitaterise" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors flex items-center justify-center w-full text-center" data-id="element-267">
              Intră în Comunitatea R.I.S.E.
            </a>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors flex items-center justify-center w-full text-center" data-id="element-268">
              Rezervă Sesiunea Cadou 1 la 1 de Coaching
            </a>
          </div>
        </div>
      </div>
    </section>;
}